import React from 'react'
import ReactDOM from 'react-dom'
import { HelmetProvider } from 'react-helmet-async'
import App from './App'
import './index.css'

// The initial HTML for public routes now has real, route-specific
// <meta>/<link>/<script type="application/ld+json"> tags injected
// server-side (backend/src/middleware/publicRender.js), marked
// data-ssr="true" - so a crawler that never runs JS still sees them.
// react-helmet-async has no built-in way to adopt/replace tags it didn't
// render itself (verified: without this, hydration left two copies of
// every tag - one server-injected, one from Helmet - instead of Helmet
// taking over). Removing the marked tags right before mount, before
// Helmet ever renders its own set, gives a clean one-tag handoff instead.
// <title> and #root's content need no such cleanup: <title> is a browser
// singleton Helmet overwrites unconditionally, and plain ReactDOM.render()
// (not hydrate()) already replaces #root's children outright on mount.
document.querySelectorAll('[data-ssr="true"]').forEach((el) => el.remove())

ReactDOM.render(
  <HelmetProvider><App/></HelmetProvider>,
  document.getElementById('root')
)